import { SupportedDomains } from '../platform';

export { isEnvironment, isProduction } from './environment';
export { call } from './functions/call';
export { parse, parseObject, parseSize } from './parse';
export type { SizeObject } from './parse';
export { delay } from './promises/delay';
export { JSON_PRETTY, stringify, toJS, toString } from './strings';

const redirectToPlatform = (url, platform, message = '') => {
    setTimeout(function () {
        window.location.href = url;
    }, 3000);
    throw new Error(message || `You are logged in on wrong platform. Redirecting to the correct ${platform} platform.`);
};
export const checkUserDomain = (data) => {
    if (data.redirect_url) {
        redirectToPlatform(data.redirect_url, '', 'There is some problem with your account!');
        return;
    }
    if (data.subdomain) {
        redirectToPlatform(`https://${data.subdomain}.gamebreaker.com`, data.subdomain);
        return;
    }
    if (data.user_platform) {
        const Platforms = {
            apparel: SupportedDomains.APPAREL_ORDER,
            gamebreaker: SupportedDomains.GAMEBREAKER_ORDER,
            p3inc: SupportedDomains.P3INC_ORDER,
        };
        redirectToPlatform(Platforms[data.user_platform], data.user_platform);
    }
};
